if (!customElements.get('sticky-scroll')) {
  class StickyScroll extends HTMLElement {
    constructor() {
      super();
      this.lastScrollY = window.scrollY;
      this.currentTop = 0;
      this.boundInit = this.init.bind(this);
      this.boundOnScroll = this.onScroll.bind(this);
      this.headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
      this.headerObserver = new MutationObserver(() => {
        const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--theme-sticky-header-height');
        if (headerHeight !== this.headerHeight) {
          this.headerHeight = headerHeight;
          this.init();
        }
      });
      this.init();
    }

    connectedCallback() {
      window.addEventListener('on:debounced-resize', this.boundInit);
      this.headerObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['style'] });
    }

    disconnectedCallback() {
      window.removeEventListener('on:debounced-resize', this.boundInit);
      window.removeEventListener('scroll', this.boundOnScroll);
      this.headerObserver.disconnect();
    }

    init() {
      // Inline top masks the CSS offset, so clear it before measuring a changed header.
      this.style.top = '';
      const computedStyle = getComputedStyle(this);
      const previousOffset = this.initialOffset || 0;

      // Sticky - attach if unattached
      if (computedStyle.position === 'sticky' && !this.attached) {
        this.initialOffset = parseInt(computedStyle.top, 10) || 0;
        this.lastScrollY = window.scrollY;
        window.addEventListener('scroll', this.boundOnScroll, { passive: true });
        this.attached = true;

      // Still sticky - keep the column in place relative to the resized header.
      } else if (computedStyle.position === 'sticky') {
        this.initialOffset = parseInt(computedStyle.top, 10) || 0;
        if (this.offsetHeight > window.innerHeight) {
          const minTop = window.innerHeight - this.offsetHeight;
          this.currentTop = Math.max(minTop, Math.min(this.initialOffset, this.currentTop + this.initialOffset - previousOffset));
          this.style.top = `${this.currentTop}px`;
        } else {
          this.currentTop = 0;
        }
        this.lastScrollY = window.scrollY;

      // Not sticky - detach if attached
      } else if (computedStyle.position !== 'sticky' && this.attached) {
        window.removeEventListener('scroll', this.boundOnScroll);
        this.attached = false;
        this.currentTop = 0;
        this.lastScrollY = window.scrollY;
      }
    }

    onScroll() {
      // Only update on requestAnimationFrame
      if (!this.waitingToUpdate) {
        window.requestAnimationFrame(() => {
          this.updatePosition();
          this.waitingToUpdate = false;
        });
        this.waitingToUpdate = true;
      }
    }

    updatePosition() {
      const scrollDelta = window.scrollY - this.lastScrollY;
      const viewportHeight = window.innerHeight;
      const elementHeight = this.offsetHeight;

      // Do not set top if element is taller than the viewport
      if (elementHeight <= viewportHeight) {
        this.style.top = '';
        this.lastScrollY = window.scrollY;
        return;
      }

      const minTop = viewportHeight - elementHeight;
      const maxTop = this.initialOffset;

      this.currentTop -= scrollDelta;
      this.currentTop = Math.max(minTop, Math.min(maxTop, this.currentTop));

      this.style.top = `${this.currentTop}px`;
      this.lastScrollY = window.scrollY;
    }
  }

  customElements.define('sticky-scroll', StickyScroll);
}
